import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import BubbleChartOutlined from '@mui/icons-material/BubbleChartOutlined'

import ReportingOverviewDashboard from 'containers/Reporting/Overview'
import Participants from 'containers/Participants'
import ParticipantProfile from 'containers/ParticipantProfile'
import StakeholderDashboard from 'containers/Reporting/StakeholderDashboard'
import TextAnalysis from 'containers/TextAnalysis'

export const getDefaultRoutes = () => [
  {
    path: '/adm',
    component: ReportingOverviewDashboard,
    name: 'dashboard',
    breadcrumbIcon: BubbleChartOutlined,
  },
  {
    path: '/adm/participants',
    component: Participants,
    name: 'participants',
    breadcrumbIcon: DashboardOutlinedIcon,
  },
  {
    path: '/adm/participant/:id',
    component: ParticipantProfile,
    breadcrumbIcon: DashboardOutlinedIcon,
  },
  {
    path: '/adm/text_analysis/:source_id',
    component: TextAnalysis,
    name: 'textanalysis',
    breadcrumbIcon: DashboardOutlinedIcon,
  },
  {
    path: '/adm/text_analysis',
    component: TextAnalysis,
    name: 'textanalysis',
    breadcrumbIcon: DashboardOutlinedIcon,
  },
]

export const publicRoutes = [
  {
    path: '/adm/pv/:id',
    component: StakeholderDashboard,
    breadcrumbIcon: BubbleChartOutlined,
    name: 'stakeholder_view',
  },
]
